import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import { Alert } from 'bootstrap';

import '../components/axios.js';
import { getPublicUrl, getWwwUrl } from '../components/utils.js';
import ReCaptchaService from '../services/recaptcha-service.js';

window.dataLayer = window.dataLayer || [];

class Category {
	constructor() {
		console.log('Category page loaded');
		window.reCaptchaService = this.reCaptchaService = new ReCaptchaService();
		this.reCaptchaService.init(); // TODO: it can be deleted after public.js isn't used anymore

        this.moreButton = document.getElementById('more-button');
        this.companyList = document.querySelector('#primary .list-body');
        this.url = getPublicUrl() + '/api' + window.location.href.replace(getPublicUrl(), '').replace(getWwwUrl(), '').replace('/v2', '').split('?')[0];
        this.page = 0;
        this.filterStates = {
            sorted: 'rating',
            rating: null,
            location: null,
            categories: [],
        };

		if(typeof grecaptcha === 'undefined') {
			console.log('grecaptcha is not defined');
			this.reCaptchaService.once('grecaptcha_loaded', () =>{
				console.log('grecaptcha_loaded');
				setTimeout(() => this.setFilterStates(), 500);
			});
		} else {
			this.setFilterStates();
		}

        this.initEventListeners();
	}

	initEventListeners() {
        document.querySelector('form.sorting select').addEventListener('change', (e) => {
            e.preventDefault();
            this.filterStates.sorted = e.target.value;
            this.companyList.classList.add('loading');
            this.filterCompanies(() => {
                this.companyList.classList.remove('loading');
            });
        });

        document.querySelectorAll('form.main-filters select, form.main-filters input').forEach((element) => {
            element.addEventListener('change', (e) => {
                e.preventDefault();
                if (e.target.name === 'categories[]') {
                    if (e.target.checked) {
                        this.filterStates.categories.push(e.target.value);
                    } else {
                        this.filterStates.categories = this.filterStates.categories.filter((category) => category !== e.target.value);
                    }
                } else {
                    this.filterStates[e.target.name] = e.target.value;
                }
                this.companyList.classList.add('loading');
                this.filterCompanies(() => {
                    this.companyList.classList.remove('loading');
                });
            });
        });

        document.querySelector('form.main-filters').addEventListener('submit', (e) => {
            e.preventDefault();
            this.companyList.classList.add('loading');
            this.filterCompanies(() => {
                this.companyList.classList.remove('loading');
            });
        });

        this.moreButton.addEventListener('click', (event) => {
            event.preventDefault();
            if (this.moreButton.classList.contains('loading')) {
                return false;
            }
            this.moreButton.classList.add('loading');
            this.moreCompanies(() => {
                this.moreButton.classList.remove('loading');
            });
        });
    }

    moreCompanies(callback) {
		this.companyList.classList.add('loading');
        this.reCaptchaService.runWithCaptcha(
            "category_companies_page",
            (token, withCheckbox = false) => {
                return axios
                    .post(this.url, { ...this.filterStates, recaptcha_token: token, recaptcha_checkbox: withCheckbox, page: ++this.page })
                    .then((response) => {
                        console.log("category_companies_page", response);
                        this.companyList.insertAdjacentHTML('beforeend', response.data.html);
                        this.checkAvailablePages(response.data.canPaginate);
						this.companyList.classList.remove('loading');
                        if (callback) callback();
                    })
                    .catch((error) => {
                        console.error("category_companies_page", error);
						this.companyList.classList.remove('loading');
                        if (callback) callback();
                    });
            }
        );
    }

    filterCompanies(callback) {
		console.log('filterCompanies', this.filterStates);
		this.companyList.classList.add('loading');
        this.reCaptchaService.runWithCaptcha(
            "category_companies_filter",
            (token, withCheckbox = false) => {
                return axios
                    .post(`${this.url}?filter=${Date.now()}`, { ...this.filterStates, recaptcha_token: token, recaptcha_checkbox: withCheckbox })
                    .then((response) => {
                        console.log("category_companies_filter", response);
                        this.companyList.innerHTML = response.data.html;
                        this.checkAvailablePages(response.data.canPaginate);
                        document.querySelector('#primary .list-header > span').textContent = response.data.records;
						this.companyList.classList.remove('loading');
                        if (callback) callback();
                    })
                    .catch((error) => {
                        console.error("category_companies_filter", error);
						this.companyList.classList.remove('loading');
                        if (callback) callback();
                    });
            }
        );
    }

    setFilterStates() {
        const urlParams = new URLSearchParams(window.location.search);

		if (urlParams.get('sorted') === null && urlParams.get('rating') === null && urlParams.get('location') === null && urlParams.getAll('categories[]').length === 0) {
			return false;
		}

        this.filterStates.sorted = urlParams.get('sorted');
        this.filterStates.rating = urlParams.get('rating');
        this.filterStates.location = urlParams.get('location');
        this.filterStates.categories = urlParams.getAll('categories[]');

        const sortingForm = document.querySelector('form.sorting');
        if (this.filterStates.sorted) {
            const option = sortingForm.querySelector(`select option[value="${this.filterStates.sorted}"]`);
            if (option) option.selected = true;
        }

        const filterForm = document.querySelector('form.main-filters');
        if (this.filterStates.rating) {
            const input = filterForm.querySelector(`input[name="rating"][value="${this.filterStates.rating}"]`);
            if (input) input.checked = true;
        }
        if (this.filterStates.location) {
            const option = filterForm.querySelector(`select[name="location"] option[value="${this.filterStates.location}"]`);
            if (option) option.selected = true;
        }
        if (this.filterStates.categories.length > 0) {
            filterForm.querySelectorAll('input[name="categories[]"]').forEach((element) => {
                element.checked = this.filterStates.categories.includes(element.value);
            });
        }

		this.filterCompanies();
    }

    checkAvailablePages(canPaginate = true) {
        if (this.moreButton) {
            this.moreButton.style.display = canPaginate ? 'inline-block' : 'none';
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
	new Category();
});